"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var firebase = __importStar(require("firebase/app"));
var editor_web_1 = require("@21st-night/editor-web");
var dayjs_1 = __importDefault(require("dayjs"));
var helpers_1 = require("../../helpers");
var FirebaseProvider_1 = require("../../providers/FirebaseProvider");
var useDeckApi = function (deckProp) {
    var _a = FirebaseProvider_1.useFirebase(), db = _a.db, authorId = _a.userId;
    var _b = __read(react_1.useState(false), 2), timeLogCreated = _b[0], setTimeLogCreated = _b[1];
    var did = deckProp.id;
    var uid = deckProp.userId;
    var createDeckRef = react_1.useCallback(function (uid, deckId) {
        return db.collection('users').doc(uid).collection('decks').doc(deckId);
    }, [db]);
    var update = react_1.useCallback(function (data, userId, deckId) {
        if (userId === void 0) { userId = uid; }
        if (deckId === void 0) { deckId = did; }
        var deckRef = createDeckRef(userId, deckId);
        return deckRef.update(__assign(__assign({}, data), { lastActivity: new Date() }));
    }, [createDeckRef, did, uid]);
    /**
     * Updates the lastActivity timestamp on the deck.
     */
    var updateLastActivity = react_1.useCallback(function (userId, deckId) {
        if (userId === void 0) { userId = uid; }
        if (deckId === void 0) { deckId = did; }
        return update({
            lastActivity: new Date(),
        }, userId, deckId);
    }, [did, uid, update]);
    /**
     * Adds an existing card to the deck.
     */
    var addCardToDeck = react_1.useCallback(function (cardId, data, userId, deckId) {
        var _a;
        if (userId === void 0) { userId = uid; }
        if (deckId === void 0) { deckId = did; }
        var card = helpers_1.createDeckCard(data);
        // If this is the first card on the deck
        // set the next review to now so that the user
        // can review it immedeatly as part of the onboarding.
        if (Object.keys(deckProp.cards).length === 0) {
            card.nextReview = new Date();
        }
        return update((_a = {},
            _a["cards." + cardId] = card,
            _a), userId, deckId);
    }, [did, deckProp, uid, update]);
    /**
     * Adds/updates a cheat-sheet document on the deck.
     */
    var addCardSummaryToCheatSheet = react_1.useCallback(function (cardId, data, userId, deckId) {
        if (userId === void 0) { userId = uid; }
        if (deckId === void 0) { deckId = did; }
        var deckRef = createDeckRef(userId, deckId);
        return deckRef
            .collection('cheat-sheet')
            .doc(cardId)
            .set(helpers_1.createCardSummaryDocument(cardId, data));
    }, [createDeckRef, did, uid]);
    /**
     * Creates a new card on the deck.
     */
    var addCard = react_1.useCallback(function (data, userId, deckId) {
        if (userId === void 0) { userId = uid; }
        if (deckId === void 0) { deckId = did; }
        return __awaiter(void 0, void 0, void 0, function () {
            var cardRef, cardDocument, promises;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!authorId) {
                            throw new Error('User is not signed in.');
                        }
                        cardRef = data.id
                            ? db.collection('cards').doc(data.id)
                            : db.collection('cards').doc();
                        cardDocument = __assign(__assign({}, helpers_1.serializeCardFormData(data)), { author: authorId, owner: userId, createdAt: new Date(), deck: deckId });
                        promises = [
                            cardRef.set(cardDocument),
                            addCardToDeck(cardRef.id, data, userId, deckId),
                        ];
                        if (cardDocument.summary) {
                            promises.push(addCardSummaryToCheatSheet(cardRef.id, data, userId, deckId));
                        }
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, cardRef.id];
                }
            });
        });
    }, [addCardToDeck, addCardSummaryToCheatSheet, authorId, db, did, uid]);
    var addCardBatch = react_1.useCallback(function (allCards, userId, deckId) {
        if (userId === void 0) { userId = uid; }
        if (deckId === void 0) { deckId = did; }
        return __awaiter(void 0, void 0, void 0, function () {
            var cards, deckUpdate, categories, subcategories, promises;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!authorId) {
                            throw new Error('User is not signed in.');
                        }
                        cards = allCards.slice(0, 500);
                        deckUpdate = {};
                        categories = [];
                        subcategories = [];
                        promises = [];
                        cards.forEach(function (card) {
                            if (card.question && card.answer) {
                                var question = card.question, answer = card.answer, explanation = card.explanation, summary = card.summary;
                                var cardDocument = {
                                    question: question,
                                    answer: answer,
                                    author: authorId,
                                    owner: userId,
                                    createdAt: new Date(),
                                    deck: deckId,
                                };
                                if (explanation) {
                                    cardDocument.explanation = explanation;
                                }
                                if (summary) {
                                    cardDocument.summary = summary;
                                }
                                var cardRef = db.collection('cards').doc();
                                if (card.category && !categories.includes(card.category)) {
                                    categories.push(card.category);
                                }
                                if (card.subcategories) {
                                    card.subcategories.forEach(function (subcategory) {
                                        if (!subcategories.includes(subcategory)) {
                                            subcategories.push(subcategory);
                                        }
                                    });
                                }
                                deckUpdate["cards." + cardRef.id] = helpers_1.createDeckCard({
                                    question: editor_web_1.deserializeDocument(question),
                                    category: card.category || null,
                                    subcategories: card.subcategories || [],
                                });
                                promises.push(cardRef.set(cardDocument));
                                if (summary) {
                                    promises.push(addCardSummaryToCheatSheet(cardRef.id, { summary: editor_web_1.deserializeDocument(summary) }, userId, deckId));
                                }
                            }
                        });
                        if (categories.length) {
                            deckUpdate.categories = (_a = firebase.firestore.FieldValue).arrayUnion.apply(_a, __spread(categories));
                        }
                        if (subcategories.length) {
                            deckUpdate.subcategories = (_b = firebase.firestore.FieldValue).arrayUnion.apply(_b, __spread(subcategories));
                        }
                        promises.push(update(deckUpdate, userId, deckId));
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    }, [addCardSummaryToCheatSheet, authorId, db, did, uid, update]);
    /**
     * Removes a card from the deck.
     */
    var removeCard = react_1.useCallback(function (cardId, userId, deckId) {
        var _a;
        if (userId === void 0) { userId = uid; }
        if (deckId === void 0) { deckId = did; }
        return update((_a = {},
            _a["cards." + cardId] = firebase.firestore.FieldValue.delete(),
            _a), userId, deckId);
    }, [did, uid, update]);
    /**
     * Updates an existing card on the deck.
     */
    var updateCard = react_1.useCallback(function (card, data, userId, deckId) {
        if (userId === void 0) { userId = uid; }
        if (deckId === void 0) { deckId = did; }
        var deckRef = createDeckRef(userId, deckId);
        var promises = [];
        var deckUpdate = {};
        var question = JSON.stringify(data.question);
        var answer = JSON.stringify(data.answer);
        var hasExplanation = !editor_web_1.isDocumentEmpty(data.explanation);
        var hasSummary = !editor_web_1.isDocumentEmpty(data.summary);
        var explanation = JSON.stringify(data.explanation);
        var summary = JSON.stringify(data.summary);
        if (data.note && card.note !== data.note) {
            deckUpdate["cards." + card.id + ".note"] =
                data.note || firebase.firestore.FieldValue.delete();
        }
        if (card.category !== data.category) {
            deckUpdate["cards." + card.id + ".category"] = data.category;
        }
        if (!helpers_1.stringArraysEqual(card.subcategories, data.subcategories)) {
            deckUpdate["cards." + card.id + ".subcategories"] = data.subcategories;
        }
        if (card.question !== question) {
            var questionFirstImage = helpers_1.getFirstImage(data.question);
            if (questionFirstImage) {
                deckUpdate["cards." + card.id + ".image"] = JSON.stringify(questionFirstImage);
            }
            else {
                deckUpdate["cards." + card.id + ".image"] = firebase.firestore.FieldValue.delete();
            }
            deckUpdate["cards." + card.id + ".question"] = JSON.stringify(helpers_1.truncateRichText(data.question, 121));
        }
        if (card.deck !== deckId) {
            if (card.question !== question) {
                deckUpdate["cards." + card.id + ".question"] = question;
                deckUpdate["cards." + card.id + ".questionEdited"] = true;
            }
            if (card.answer !== answer) {
                deckUpdate["cards." + card.id + ".answer"] = answer;
            }
            if (hasExplanation && card.explanation !== explanation) {
                deckUpdate["cards." + card.id + ".explanation"] = explanation;
            }
            if (hasSummary && card.summary !== summary) {
                deckUpdate["cards." + card.id + ".summary"] = summary;
            }
        }
        else {
            promises.push(db
                .collection('cards')
                .doc(card.id)
                .update({
                question: question,
                answer: answer,
                explanation: !hasExplanation
                    ? firebase.firestore.FieldValue.delete()
                    : explanation,
                summary: !hasSummary
                    ? firebase.firestore.FieldValue.delete()
                    : summary,
            }));
        }
        if (hasSummary) {
            deckRef
                .collection('cheat-sheet')
                .doc(card.id)
                .set({
                card: card.id,
                content: summary,
            });
        }
        if (Object.keys(deckUpdate).length) {
            promises.push(update(deckUpdate, userId, deckId));
        }
        return Promise.all(promises);
    }, [createDeckRef, db, did, uid, update]);
    /**
     * Creates a new cateogry on the deck.
     */
    var addCategory = react_1.useCallback(function (name, userId, deckId) {
        if (userId === void 0) { userId = uid; }
        if (deckId === void 0) { deckId = did; }
        return update({
            categories: firebase.firestore.FieldValue.arrayUnion(name),
        }, userId, deckId);
    }, [did, uid, update]);
    /**
     * Unretires a card on the deck.
     */
    var unretireCard = react_1.useCallback(function (cardId, userId, deckId) {
        var _a;
        if (userId === void 0) { userId = uid; }
        if (deckId === void 0) { deckId = did; }
        return Promise.all([
            update((_a = {},
                _a["cards." + cardId + ".retired"] = firebase.firestore.FieldValue.delete(),
                _a), userId, deckId),
            db
                .collection('users')
                .doc(userId)
                .collection('card-progress')
                .doc(cardId)
                .set({
                retired: false,
            }, { merge: true }),
        ]);
    }, [did, uid, update, db]);
    /**
     * Renames an existing cateogry on the deck.
     */
    var renameCategory = react_1.useCallback(function (oldName, newName, userId, deck) {
        if (userId === void 0) { userId = uid; }
        if (deck === void 0) { deck = deckProp; }
        var newCategories = deck.categories.filter(function (name) { return name !== oldName; });
        newCategories.push(newName);
        var deckUpdate = {
            categories: newCategories,
        };
        deck.cards.forEach(function (card) {
            if (card.category === oldName) {
                deckUpdate["cards." + card.id + ".category"] = newName;
            }
        });
        return update(deckUpdate, userId, deck.id);
    }, [uid, deckProp, update]);
    /**
     * Deletes a category from the deck.
     */
    var removeCategory = react_1.useCallback(function (name, userId, deckId) {
        if (userId === void 0) { userId = uid; }
        if (deckId === void 0) { deckId = did; }
        return update({
            categories: firebase.firestore.FieldValue.arrayRemove(name),
        }, userId, deckId);
    }, [did, uid, update]);
    /**
     * Creates a new subcateogry on the deck.
     */
    var addSubcategory = react_1.useCallback(function (name, userId, deckId) {
        if (userId === void 0) { userId = uid; }
        if (deckId === void 0) { deckId = did; }
        return update({
            subcategories: firebase.firestore.FieldValue.arrayUnion(name),
        }, userId, deckId);
    }, [did, uid, update]);
    /**
     * Toggles the starred property of a card on the deck.
     */
    var toggleCardStarred = react_1.useCallback(function (card, userId, deckId) {
        var _a;
        if (userId === void 0) { userId = uid; }
        if (deckId === void 0) { deckId = did; }
        return update((_a = {},
            _a["cards." + card.id + ".starred"] = !card.starred,
            _a), userId, deckId);
    }, [did, uid, update]);
    /**
     * Renames an existing subcateogry on the deck.
     */
    var renameSubcategory = react_1.useCallback(function (oldName, newName, userId, deck) {
        if (userId === void 0) { userId = uid; }
        if (deck === void 0) { deck = deckProp; }
        var newSubcategories = deck.subcategories.filter(function (name) { return name !== oldName; });
        newSubcategories.push(newName);
        var deckUpdate = {
            subcategories: newSubcategories,
        };
        deck.cards.forEach(function (card) {
            if (card.subcategories && card.subcategories.includes(oldName)) {
                deckUpdate["cards." + card.id + ".subcategories"] = __spread(card.subcategories.filter(function (name) { return name !== oldName; }), [
                    newName,
                ]);
            }
        });
        return update(deckUpdate, userId, deck.id);
    }, [uid, deckProp, update]);
    /**
     * Deletes a subcategory from the deck.
     */
    var removeSubcategory = react_1.useCallback(function (name, userId, deckId) {
        if (userId === void 0) { userId = uid; }
        if (deckId === void 0) { deckId = did; }
        return update({
            subcategories: firebase.firestore.FieldValue.arrayRemove(name),
        }, userId, deckId);
    }, [did, uid, update]);
    /**
     * Rates a card on the deck.
     */
    var rateCard = react_1.useCallback(function (card, rating, currentProgress, userId, deckId) {
        var _a;
        if (userId === void 0) { userId = uid; }
        if (deckId === void 0) { deckId = did; }
        if (!userId) {
            throw new Error('User is not authenticated');
        }
        var promises = [];
        // Don't rate card if it's not due yet
        if (card.nextReview &&
            helpers_1.toDate(card.nextReview) > new Date() &&
            !dayjs_1.default().isSame(helpers_1.toDate(card.nextReview), 'day')) {
            return;
        }
        var newProgress = helpers_1.calculateNewCardProgress(currentProgress, rating);
        if (card.notStarted) {
            promises.push(db
                .collection('users')
                .doc(userId)
                .update({
                'statistics.cards-reviewed': firebase.firestore.FieldValue.increment(1),
            }));
        }
        if (newProgress.proficiency === 6) {
            promises.push(db
                .collection('users')
                .doc(userId)
                .update({
                'statistics.cards-mastered': firebase.firestore.FieldValue.increment(1),
            }));
        }
        promises.push(db
            .collection('users')
            .doc(userId)
            .collection('card-progress')
            .doc(card.id)
            .set(__assign(__assign({}, newProgress), { deckId: deckId })));
        var deckUpdate = (_a = {},
            _a["cards." + card.id + ".proficiency"] = newProgress.proficiency,
            _a["cards." + card.id + ".nextReview"] = newProgress.nextReview,
            _a["cards." + card.id + ".lastReview"] = new Date(),
            _a["cards." + card.id + ".notStarted"] = firebase.firestore.FieldValue.delete(),
            _a);
        if (newProgress.retired || (card && card.retired)) {
            deckUpdate["cards." + card.id + ".retired"] = newProgress.retired;
        }
        deckUpdate.lastReview = new Date();
        promises.push(update(deckUpdate, userId, deckId));
        return promises;
    }, [db, did, uid, update]);
    var addAnalyticsEvent = react_1.useCallback(function (data, userId, deckId) {
        if (userId === void 0) { userId = uid; }
        if (deckId === void 0) { deckId = did; }
        var deckRef = createDeckRef(userId, deckId);
        deckRef
            .collection('analytics-events')
            .add(__assign(__assign({}, data), { createdAt: new Date() }));
    }, [createDeckRef, did, uid]);
    var logTimeSpent = react_1.useCallback(function (data, userId, deckId) {
        if (userId === void 0) { userId = uid; }
        if (deckId === void 0) { deckId = did; }
        return __awaiter(void 0, void 0, void 0, function () {
            var deckRef, docId, existingLog, date;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        deckRef = createDeckRef(userId, deckId);
                        docId = dayjs_1.default(new Date()).format('DD-MM-YYYY');
                        if (!!timeLogCreated) return [3 /*break*/, 3];
                        return [4 /*yield*/, deckRef
                                .collection('time-logs')
                                .doc(docId)
                                .get()];
                    case 1:
                        existingLog = _b.sent();
                        if (!!existingLog.exists) return [3 /*break*/, 3];
                        date = new Date();
                        date.setHours(0, 0, 0, 0);
                        return [4 /*yield*/, deckRef
                                .collection('time-logs')
                                .doc(docId)
                                .set({ date: date, notes: 0 })];
                    case 2:
                        _b.sent();
                        setTimeLogCreated(true);
                        _b.label = 3;
                    case 3:
                        deckRef
                            .collection('time-logs')
                            .doc(docId)
                            .set((_a = {},
                            _a[data.type] = firebase.firestore.FieldValue.increment(data.time),
                            _a), { merge: true });
                        return [2 /*return*/];
                }
            });
        });
    }, [createDeckRef, did, timeLogCreated, uid]);
    /**
     * Adds an existing card to the deck.
     */
    var addNoteToDeck = react_1.useCallback(function (noteId, data, userId, deckId) {
        var _a;
        if (userId === void 0) { userId = uid; }
        if (deckId === void 0) { deckId = did; }
        var deckUpdate = (_a = {},
            _a["notes." + noteId] = helpers_1.createDeckNote(data),
            _a);
        if (data.cards) {
            data.cards.forEach(function (cardId) {
                deckUpdate["cards." + cardId + ".note"] = noteId;
            });
        }
        return update(deckUpdate, userId, deckId);
    }, [did, uid, update]);
    /**
     * Creates a new note on the deck.
     */
    var addNote = react_1.useCallback(function (data, userId, deckId) {
        if (userId === void 0) { userId = uid; }
        if (deckId === void 0) { deckId = did; }
        if (!authorId) {
            throw new Error('User is not signed in.');
        }
        var noteRef = db.collection('notes').doc();
        var noteDocument = {
            type: data.type || 'note',
            content: JSON.stringify(data.content),
            title: data.title,
            cards: data.cards,
            author: authorId,
            owner: userId,
            createdAt: new Date(),
            deck: deckId,
        };
        if (data.file) {
            noteDocument.file = data.file;
            noteDocument.fileId = data.fileId;
        }
        if (data.parent) {
            noteDocument.parent = data.parent;
        }
        var promises = [
            noteRef.set(noteDocument),
            addNoteToDeck(noteRef.id, data, userId, deckId),
        ];
        data.cards.forEach(function (cardId) {
            promises.push(db.collection('cards').doc(cardId).update({
                note: noteRef.id,
            }));
        });
        return noteRef.id;
    }, [addNoteToDeck, authorId, db, did, uid]);
    /**
     * Updates an existing note on the deck.
     */
    var updateNote = react_1.useCallback(function (note, data, userId, deckId) {
        if (userId === void 0) { userId = uid; }
        if (deckId === void 0) { deckId = did; }
        var promises = [];
        var deckUpdate = {};
        var content = JSON.stringify(data.content);
        if (note.title !== data.title) {
            deckUpdate["notes." + note.id + ".title"] = data.title;
        }
        if (note.category !== data.category) {
            deckUpdate["notes." + note.id + ".category"] = data.category;
        }
        if (!helpers_1.stringArraysEqual(note.subcategories, data.subcategories)) {
            deckUpdate["notes." + note.id + ".subcategories"] = data.subcategories;
        }
        if (!helpers_1.stringArraysEqual(note.cards || [], data.cards)) {
            deckUpdate["notes." + note.id + ".cards"] = data.cards;
            data.cards.forEach(function (cardId) {
                deckUpdate["cards." + cardId + ".note"] = note.id;
            });
        }
        if (note.content !== content) {
            var contentFirstImage = helpers_1.getFirstImage(data.content);
            if (contentFirstImage) {
                deckUpdate["notes." + note.id + ".image"] = JSON.stringify(contentFirstImage);
            }
            else {
                deckUpdate["notes." + note.id + ".image"] = firebase.firestore.FieldValue.delete();
            }
            deckUpdate["notes." + note.id + ".content"] = JSON.stringify(helpers_1.truncateRichText(data.content, 121));
        }
        if (note.deck !== deckId) {
            if (note.content !== content) {
                deckUpdate["notes." + note.id + ".content"] = content;
                deckUpdate["notes." + note.id + ".contentEdited"] = true;
            }
        }
        else {
            promises.push(db.collection('notes').doc(note.id).update({
                content: content,
                title: data.title,
            }));
        }
        if (Object.keys(deckUpdate).length) {
            promises.push(update(deckUpdate, userId, deckId));
        }
        return Promise.all(promises);
    }, [db, did, uid, update]);
    /**
     * Removes a note from the deck.
     */
    var removeNote = react_1.useCallback(function (note, userId, deckId) {
        var _a;
        if (userId === void 0) { userId = uid; }
        if (deckId === void 0) { deckId = did; }
        var deckUpdate = (_a = {},
            _a["notes." + note.id] = firebase.firestore.FieldValue.delete(),
            _a);
        if (note.cards) {
            note.cards.forEach(function (cardId) {
                deckUpdate["cards." + cardId + ".note"] = firebase.firestore.FieldValue.delete();
            });
        }
        var promises = [
            update(deckUpdate, userId, deckId),
            db.collection('notes').doc(note.id).delete(),
        ];
        return Promise.all(promises);
    }, [db, did, uid, update]);
    /**
     * Toggles the starred property of a note on the deck.
     */
    var toggleNoteStarred = react_1.useCallback(function (note, userId, deckId) {
        var _a;
        if (userId === void 0) { userId = uid; }
        if (deckId === void 0) { deckId = did; }
        return update((_a = {},
            _a["notes." + note.id + ".starred"] = !note.starred,
            _a), userId, deckId);
    }, [did, uid, update]);
    /**
     * Updates the lastViewed timestamp on a note.
     */
    var updateNoteLastViewed = react_1.useCallback(function (noteId, userId, deckId) {
        var _a;
        if (userId === void 0) { userId = uid; }
        if (deckId === void 0) { deckId = did; }
        return update((_a = {},
            _a["notes." + noteId + ".lastViewed"] = new Date(),
            _a), userId, deckId);
    }, [did, uid, update]);
    return {
        addAnalyticsEvent: addAnalyticsEvent,
        addCardBatch: addCardBatch,
        addCardSummaryToCheatSheet: addCardSummaryToCheatSheet,
        logTimeSpent: logTimeSpent,
        addCard: addCard,
        addCardToDeck: addCardToDeck,
        addCategory: addCategory,
        addNote: addNote,
        addNoteToDeck: addNoteToDeck,
        addSubcategory: addSubcategory,
        createDeckRef: createDeckRef,
        rateCard: rateCard,
        removeCard: removeCard,
        removeCategory: removeCategory,
        removeNote: removeNote,
        removeSubcategory: removeSubcategory,
        renameCategory: renameCategory,
        renameSubcategory: renameSubcategory,
        toggleCardStarred: toggleCardStarred,
        toggleNoteStarred: toggleNoteStarred,
        update: update,
        updateCard: updateCard,
        updateLastActivity: updateLastActivity,
        updateNote: updateNote,
        updateNoteLastViewed: updateNoteLastViewed,
        unretireCard: unretireCard,
    };
};
exports.default = useDeckApi;
//# sourceMappingURL=useDeckApi.js.map